<nav *ngIf='!hideMenu' class='navbar navbar-expand-xl'>
  <div class='navbar-logo-wrapper'>
    <a class='navbar-brand me-0' href="/order-new/start">
      <img *ngIf='environment.environmentType !== EnvironmentType.Production'
           src='assets/img/logo/Nobina_logo_vit.svg' alt='Nobina logo' class='navbar-logo'>
      <img *ngIf='environment.environmentType === EnvironmentType.Production'
           src='assets/img/logo/nobina-logo-2020.svg' alt='Nobina logo'>
    </a>
    <div *ngIf='environment.environmentType !== EnvironmentType.Production'
         class='environment-name' style="font-size: 12px">{{ environment.environmentType }}
    </div>
    <button (click)='toggleCollapsed()' class='navbar-toggler' type='button' data-toggle='collapse'
            data-target='#navbarSupportedContent'
            aria-controls='navbarSupportedContent' aria-expanded='false' aria-label='Toggle navigation'>
      <i class='fa fa-bars text-white'></i>
    </button>
  </div>

  <div [ngClass]="{'collapse': collapsed, 'mb-2': !collapsed, 'navbar-collapse': true}" id='navbarSupportedContent'>
    <ul class='navbar-nav mx-auto' [ngClass]="{'mb-2': !collapsed}">
      <ng-container *ngFor="let link of links; let i = index; trackBy: trackByIndex">

        <!-- Submenu dropdown -->
        <li *ngIf="link.subMenu"
            class='nav-item nav-item-dropdown'
            [class.active]="subRouteActiveStates[i]"
            (mouseenter)="openOnHover(i)"
            (mouseleave)="closeOnHover()">
          <button class='nav-link nav-btn d-flex align-items-center'
                  [attr.aria-haspopup]="true"
                  [attr.aria-expanded]="openIndex === i"
                  (click)="toggleMenu(i)">
            {{ link.label }}
            <svg class='nav-chevron ms-1'
                 [class.nav-chevron--open]="openIndex === i"
                 viewBox="0 0 12 12" fill="currentColor" aria-hidden="true">
              <path d="M6 8L1 3h10z" />
            </svg>
          </button>
          <ul *ngIf="openIndex === i" role="menu" class='nav-submenu'>
            <li *ngFor="let subLink of link.subMenu; let last = last; trackBy: trackByIndex"
                role="none"
                class='nav-submenu-item'
                [class.nav-submenu-item--last]="last">
              <a *ngIf="subLink.isExternal; else internalSubLink"
                 [href]="subLink.address"
                 role="menuitem"
                 class='nav-submenu-link'
                 (click)="closeSubMenu()">
                <span class='nav-submenu-link-text'>{{ subLink.label }}</span>
              </a>
              <ng-template #internalSubLink>
                <a [routerLink]="subLink.address"
                   routerLinkActive="nav-submenu-link--active"
                   role="menuitem"
                   class='nav-submenu-link'
                   (click)="closeSubMenu()">
                  <span class='nav-submenu-link-text'>{{ subLink.label }}</span>
                </a>
              </ng-template>
            </li>
          </ul>
        </li>

        <!-- Flat external link -->
        <li *ngIf="!link.subMenu && link.isExternal"
            class='nav-item'
            [class.active]="isLinkActive(link)">
          <a class='nav-link' [href]="link.address" (click)='collapseMenu()'>{{ link.label }}</a>
        </li>

        <!-- Flat internal link -->
        <li *ngIf="!link.subMenu && !link.isExternal"
            class='nav-item'
            routerLinkActive='active'>
          <a class='nav-link' [routerLink]="link.address" (click)='collapseMenu()'>{{ link.label }}</a>
        </li>

      </ng-container>
    </ul>
    <app-search class='me-auto'></app-search>
  </div>
  <ul class='navbar-nav' [ngClass]="{'ms-auto': collapsed, 'me-auto': !collapsed}">
    <li class='nav-item'>
      <a id='navbarSearch' class='nav-link' href='/order-new/search'>
        <img class='menu-icon' src='assets/img/icons/search-white.png' alt='Search icon'/>
      </a>
    </li>
    <li class='nav-item me-2'>
          <span class='notification-wrapper'>
            <div (click)='openNotifications(); collapseMenu()' id='nav-link-padding' class='nav-link'>
              <span *ngIf='numberOfUnreadNotifications' class='red-dot'>{{ numberOfUnreadNotifications }}</span>
              <img class='menu-icon' src='assets/img/icons/notification.png' alt='Notification icon'/>
            </div>
          </span>
    </li>
  </ul>
  <div ngbDropdown>
    <a id='nav-link-padding' class='nav-link d-flex align-items-center' ngbDropdownToggle>
      <img class='user-icon' src='assets/img/icons/account.png' alt='Account icon'/>
      <p class='m-0 ms-1 d-none d-sm-block'>{{ displayedUserName }}</p>
    </a>
    <div ngbDropdownMenu class='dropdown-menu-end dropdown-menu-xxxxl-start'>
      <div class='dropdown-body'>
        <div class='px-3 pb-3'>
          <div *ngIf='userEmail'>{{ userEmail }}</div>
          <br *ngIf='userEmail'/>
          <div class="dropdown-header" *ngIf="isSingleRole" i18n="@@app.my-role">Min roll:</div>
          <div class="dropdown-header" *ngIf="!isSingleRole" i18n="@@app.my-roles">Mina roller:</div>
          <div>{{ myUserRoles }}</div>
          <br/>
          <div class="dropdown-header" i18n='@@app.my-organisation'>Mina organisationer:</div>
          <div>{{ myOrganisation }}</div>
        </div>

        <a *ngIf='userOperatorId' href='/garage/operator/{{userOperatorId}}/users' class='dropdown-item p-3'>
          <img class='menu-icon' src='assets/img/icons/user-cog.png' alt='User management'/>
          <ng-container i18n='@@app.manage-operator-users'>Hantera användare</ng-container>
        </a>

        <a *ngIf='userGarageId$ | async as garageId' href='/garage/{{garageId}}/users' class='dropdown-item p-3'>
          <img class='menu-icon' src='assets/img/icons/bus.png' alt='Garage icon'/>
          <ng-container i18n='@@app.manage-garage'>Hantera mitt garage</ng-container>
        </a>
        <a class='dropdown-item p-3' href="/order-new/manage-operators"
           *ngIf='showOperatorMenu'>
          <img class='menu-icon' src='assets/img/icons/user-cog.png' alt='User settings icon'/>
          <ng-container i18n='@@app.select-operators'>Välj operatörer</ng-container>
        </a>
        <a *ngIf='showUEManual' href='{{ueManualPath}}' target="_blank" class='dropdown-item p-3'>
          <img class='menu-icon' src='assets/img/icons/manual.png' alt='User manual'/>
          <ng-container i18n='@@app.user-manual'>Manual</ng-container>
        </a>

        <a *ngIf='showManual' href='{{manualPath}}' target="_blank" class='dropdown-item p-3'>
          <img class='menu-icon' src='assets/img/icons/manual.png' alt='User manual'/>
          <ng-container i18n='@@app.user-manual'>Manual</ng-container>
        </a>
        <div ngbDropdown>
          <div type="button" ngbDropdownToggle class="btn d-flex align-items-center" id="language-dropdown">
            <img [ngSrc]="currentFlag" width="26" height="26" alt=""/>
            <span class="ms-2">{{currentLanguage}}</span>
          </div>
          <div ngbDropdownMenu aria-labelledby="language-dropdown">
            <button ngbDropdownItem (click)='changeLanguage("dk")' class="d-flex align-items-center">
              <img src="assets/img/flags/danish.svg" width="26" height="26" alt=""/>
              <span class="ms-2">Dansk</span>
            </button>
            <button ngbDropdownItem (click)='changeLanguage("fi")' class="d-flex align-items-center">
              <img src="assets/img/flags/finish.svg" width="26" height="26" alt=""/>
              <span class="ms-2">Suomeksi</span>
            </button>
            <button ngbDropdownItem (click)='changeLanguage("nb")' class="d-flex align-items-center">
              <img src="assets/img/flags/norwegian.svg" width="26" height="26" alt=""/>
              <span class="ms-2">Norsk</span>
            </button>
            <button ngbDropdownItem (click)='changeLanguage("sv")'>
              <img src="assets/img/flags/swedish.svg" width="26" height="26" alt=""/>
              <span class="ms-2">Svenska</span>
            </button>
          </div>
        </div>
        <a id='logout' class='dropdown-item p-3' (click)='logout()'>
          <img class='menu-icon' src='assets/img/icons/log-out.png' alt='Logout icon'/>
          <ng-container i18n='@@app.log-out'>Logga ut</ng-container>
        </a>
      </div>
    </div>
  </div>
</nav>
